module.exports = __webpack_public_path__ + "img/revistas_pregoeiro.8ace9dde.png";